module.exports = __webpack_public_path__ + "img/pic_tltw_bxssy_selected@2x.38020248.png";